(function () {

    'use strict';

    angular
        .module('app.search')
        .factory('UrlCreationService', [
            '$location',
            UrlCreatorService
        ]);

    function UrlCreatorService($location) {
        return {
            createUrl: function (search) {
                var url = $location.protocol() + "://" + $location.host() + ":" + $location.port() + window.location.pathname + "?";
                var params = $location.search();
                for (var i in params) if (params.hasOwnProperty(i))
                    url += "&" + i + "=" + params[i];
                if (search) url += "&action=searchResult";
                return url;
            }
        }
    }

})();


// WEBPACK FOOTER //
// ./app/search/components/service/UrlCreationService.js